import { render, staticRenderFns } from "./followMsgModal.vue?vue&type=template&id=03b92960&scoped=true"
import script from "./followMsgModal.vue?vue&type=script&lang=js"
export * from "./followMsgModal.vue?vue&type=script&lang=js"
import style0 from "./followMsgModal.vue?vue&type=style&index=0&id=03b92960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b92960",
  null
  
)

export default component.exports